var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56.4019,
    height: 56.4019,
    rx: 28.2009,
    fill: "#2A71FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1536 37.6015C18.9503 37.6015 17.2728 36.8003 16.1211 35.1979C14.9694 33.5955 14.3935 31.2921 14.3935 28.2876C14.3935 25.2831 14.9694 22.9797 16.1211 21.3773C17.2728 19.7749 18.9503 18.9737 21.1536 18.9737C23.3569 18.9737 25.0344 19.7749 26.1862 21.3773C27.3379 22.9797 27.9137 25.2831 27.9137 28.2876C27.9137 31.3171 27.3379 33.6206 26.1862 35.223C25.0344 36.8254 23.3569 37.6015 21.1536 37.6015ZM21.1536 35.273C23.8076 35.273 25.1346 32.9446 25.1346 28.2876C25.1346 23.6307 23.8076 21.3022 21.1536 21.3022C18.4997 21.3022 17.1977 23.6307 17.1977 28.2876C17.1977 32.9446 18.4997 35.273 21.1536 35.273ZM33.0319 34.8725H42.3458V37.2009H30.0274L30.1025 36.0742C30.1526 34.8725 30.428 33.6957 30.9288 32.569C31.4796 31.2921 32.6063 30.2155 34.3339 29.3141L36.3619 28.1875C37.4135 27.6366 38.1896 27.0608 38.6653 26.4599C39.116 25.859 39.3664 25.1329 39.3664 24.2816C39.3664 23.3803 39.0659 22.6542 38.4901 22.1034C37.9142 21.5776 37.113 21.3022 36.1115 21.3022C33.8081 21.3022 32.6814 22.504 32.6814 24.8825H30.0525C30.0274 23.0298 30.5532 21.5776 31.6298 20.526C32.6814 19.4995 34.2087 18.9737 36.1866 18.9737C37.9893 18.9737 39.4165 19.4745 40.4931 20.4259C41.5697 21.4274 42.1205 22.6792 42.1205 24.1815C42.1205 25.4334 41.77 26.535 41.0689 27.4864C40.3679 28.4378 39.2662 29.3141 37.764 30.1153L35.9863 31.1168C34.9598 31.6927 34.2337 32.2435 33.783 32.7943C33.3324 33.3452 33.082 34.0462 33.0319 34.8725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Blue);
export default __webpack_public_path__ + "static/media/02-blue.c0faa201a3d9a8b95cd3cb04cd191e8f.svg";
export { ForwardRef as ReactComponent };